// extracted by mini-css-extract-plugin
module.exports = {"formGroupLabel":"FormGroupLabel_formGroupLabel__GBOwN","formGroupLabelWithError":"FormGroupLabel_formGroupLabelWithError__1tX_5"};